import React from "react"

const QuiverL = ({
  colors = [
    "#542911",
    "#8A5D3B",
    "#C3996B",
    "#6E634F",
    "#4076B7",
    "#42A2DA",
    "#9E7731",
    "#359B5A",
    "#63C197"
  ]
}) => {
  return (
    <g id="QuiverL">
      <path
        fill={colors[0]}
        d="M84.4,83L79,59.4l0-0.2l0,0c0-0.4,0-0.7,0.1-1l-0.8-3.3L77.4,53c-0.1-0.3-0.2-0.6-0.2-0.9L77,50.6 c0,0,0.5,0.4,0.5,0.5l0.5-0.1c0,0,0.1-0.3,0.1-0.3l-0.3-0.8c-0.1-0.3-0.2-0.6-0.2-0.9l-0.1-1.6c0,0,0.5,0.5,0.5,0.5l0.5-0.1 c0,0,0.3-0.5,0.3-0.5l0.6,1.3c0.1,0.3,0.2,0.6,0.2,0.9l0,0.7c0,0,0.3,0.4,0.3,0.4l0.5-0.1c0,0,0,0,0,0l-0.6-1.5 c-0.1-0.3-0.2-0.6-0.2-0.9l-0.1-1.6c0,0,0.5,0.5,0.5,0.5l0.5-0.1c0,0,0.3-0.5,0.3-0.5l0.6,1.3c0.1,0.3,0.2,0.6,0.2,0.9l-0.1,0.9 c0,0,0.2,0.2,0.2,0.2l0.5-0.1c0,0,0.3-0.5,0.3-0.5l0.5,1.3c0.1,0.3,0.2,0.6,0.2,0.9l-0.1,1.5l0.7,4c0.1,0.1,0.1,0.1,0.2,0.2l0.1,0 l0.1,0.2c0.1,0.1,5.2,12.2,2.7,23l0,0.1L84.4,83z"
      />
      <path
        fill={colors[1]}
        d="M86.1,80.2l-1.6,2.2l-5.3-23.1l4.2-1.9C83.4,57.3,88.6,69.3,86.1,80.2z"
      />
      <path
        opacity="0.62"
        fill={colors[2]}
        d="M79.8,62.1l4.7,20.5l1.6-2.2c1.8-7.6-0.3-15.9-1.7-20.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1-0.7-0.2-1.2-0.3-1.7c-0.1-0.3-0.2-0.5-0.2-0.7c0,0,0,0-0.1,0c0.2,0.9,0.3,1.4,0.5,2.4c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2-0.9-0.3-1.5-0.5-2.3c0,0.1-0.1,0.2-0.1,0.3c0.1,0.7,0.3,1.3,0.4,2.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.8-0.3-1.3-0.4-1.9 c0,0.1-0.1,0.1-0.1,0.2c0.1,0.5,0.2,1.1,0.4,1.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.7-0.3-1.2-0.4-1.7c0,0-0.1,0.1-0.1,0.1 c0.1,0.5,0.2,1,0.4,1.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.6-0.2-1.2-0.3-1.7c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1 c0.1,0.5,0.2,1,0.3,1.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1-0.6-0.2-1.2-0.3-1.7c-0.1,0-0.1,0-0.2,0.1c0.1,0.5,0.2,1,0.4,1.7 C82.1,62,82,62,81.9,62.1c-0.1-0.7-0.3-1.2-0.4-1.8c0,0-0.1,0.1-0.1,0.1c0.1,0.5,0.2,1.1,0.4,1.7c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.1-0.7-0.3-1.3-0.4-1.8c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0.1,0.6,0.2,1.1,0.4,1.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.8-0.3-1.4-0.4-2 c-0.1,0-0.1,0-0.2,0c0.1,0.6,0.3,1.3,0.4,2.1c-0.1,0.1-0.2-0.4-0.3-0.3c-0.2-0.9-0.3-1.2-0.4-1.9c-0.1,0-0.1,0-0.2,0 c0.2,0.7,0.2,0.8,0.4,1.8c-0.1,0.1-0.2-0.4-0.3-0.3c-0.2-1.1-0.2-0.8-0.3-1.6c-0.1,0-0.1-0.1-0.2-0.1c0.2,0.9,0.1,0.5,0.4,1.7 C79.9,61.9,79.7,61.6,79.8,62.1z M83.5,67c0.1,0.1,0.3,0.2,0.4,0.4c0.1,0.1-0.3,0.2-0.3,0.2c-0.1,0-0.4,0-0.5-0.1 c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1,0.3-0.2,0.3-0.2C83.1,66.9,83.3,66.9,83.5,67z M85.1,66.8c-0.7,0.3-2.1-0.1-2.4-0.8 c-0.3-0.7-0.5-2.1,0.3-2.3c0,0,1.9,1.3,2,1.3c-0.2-0.4-1.5-1.7-1.7-2.1c-0.1-0.1,0.7-0.3,0.8-0.1C84.6,63.6,86.2,66.3,85.1,66.8z M86,74.5c0,0.2-0.9,1.2-0.9,1.1c0.5-2.4-0.3-5.1-0.8-7.5c0-0.1,0.9-1.5,1.3-0.2C86.2,70.4,86.5,72.1,86,74.5z M84.5,80.7 c0.1-0.5,0.2-1,0.3-1.6c-0.2,0-0.3-0.1-0.1-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c-0.1-0.3-0.2-0.7-0.2-1 c-0.2,0-0.3-0.1-0.1-0.1c0,0,0.1,0,0.1,0c0-0.2,0-0.4,0-0.5c-0.3,0-0.7-0.1-0.4-0.2c0.1,0,0.3,0,0.4,0c0.1-0.2,0.2-0.3,0.4-0.4 c-0.3,0-0.6-0.1-0.4-0.2c0.1,0,0.5,0,0.7,0.1c0,0,0-0.1,0-0.1c0-0.1,0.8-0.2,0.9,0c0.1,0.3,0.1,0.7,0,0.9c0,0.2,0,0.4,0,0.6 c0,0,0,0,0,0c0.3,0,0.5,0.1,0.3,0.2c0,0-0.2,0-0.3,0c0,0.1,0,0.3-0.1,0.4c0.2,0,0.4,0.1,0.2,0.1c0,0-0.1,0-0.2,0 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.6-0.2,1.2-0.4,1.8C85.3,80.9,84.5,80.8,84.5,80.7z"
      />
      <path
        fill={colors[0]}
        d="M79.3,59.4c-0.7-2.5,3.2-3.7,4.2-2S80.2,62.4,79.3,59.4z"
      />
      <path
        fill={colors[0]}
        d="M80.6,60.5c0.2,1.5,0.5,3.1,0.9,4.6c0.3,1.5,0.6,3,0.9,4.5c0.3,1.5,0.7,3.1,1,4.6c0.3,1.5,0.7,3,1,4.6l0,0 c0.1,0.6,0.1,1.2,0.2,1.8c0,0.6,0.1,1.2-0.1,1.7l0,0c0.1-0.6,0.1-1.2,0.1-1.8c0-0.6-0.1-1.2-0.1-1.8l0,0l0,0 c-0.3-1.5-0.6-3.1-0.9-4.6c-0.3-1.5-0.7-3-1-4.6c-0.4-1.5-0.6-3.1-0.9-4.6C81.4,63.6,81.1,62,80.6,60.5L80.6,60.5z"
      />
      <path
        fill="none"
        d="M80.8,52.3l1.4,7.4c-0.1,0.1-0.3,0.2-0.5,0.3l-1.1-6.3L80.8,52.3z"
      />
      <path
        fill={colors[3]}
        d="M80.8,60.3l-2.1-8.9l0.1,0.2l-0.6-2.7c0-0.1-0.1-0.2-0.1-0.3L77.9,48l0.4-0.1l0.1,0.2 c0,0.2-0.1,0.5,0,0.7l0.6,2.7l0-0.6l2.2,9.3C81.1,60.3,80.9,60.3,80.8,60.3z"
      />
      <path
        fill={colors[4]}
        d="M77.9,49.6c-0.1-0.2-0.2-0.5-0.2-0.8l-0.1-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.6,2.8L77.9,49.6z"
      />
      <path
        fill={colors[4]}
        d="M78.8,51.6l-0.1-0.2l-0.6-2.8c0,0.1,0.1,0.2,0.1,0.3L78.8,51.6z"
      />
      <path
        fill={colors[5]}
        d="M78.5,47.7l0.4,0.8c0.1,0.2,0.2,0.5,0.2,0.8L79,51l-0.6-2.8C78.4,48,78.5,47.9,78.5,47.7z"
      />
      <path
        fill={colors[5]}
        d="M78.4,48.9c-0.1-0.2-0.1-0.5,0-0.7L79,51l0,0.6L78.4,48.9z"
      />
      <path
        fill={colors[6]}
        d="M78.5,54.8l-0.7-2.7c0-0.1-0.1-0.2-0.1-0.3l-0.2-0.6l0.4-0.1l0.1,0.2c0,0.2,0,0.5,0,0.7l0.7,2.7l0-0.6 l1.6,6.2c-0.2,0-0.3-0.1-0.5-0.2l-1.4-5.5L78.5,54.8z"
      />
      <path
        fill={colors[7]}
        d="M77.6,52.8c-0.1-0.2-0.2-0.5-0.2-0.8l-0.1-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.7,2.8L77.6,52.8z"
      />
      <path
        fill={colors[7]}
        d="M78.5,54.8l-0.1-0.2l-0.7-2.8c0,0.1,0.1,0.2,0.1,0.3L78.5,54.8z"
      />
      <path
        fill={colors[8]}
        d="M78.1,50.9l0.4,0.8c0.1,0.2,0.2,0.5,0.2,0.8l0,1.6L78,51.3C78,51.2,78.1,51,78.1,50.9z"
      />
      <path
        fill={colors[8]}
        d="M78,52.1c-0.1-0.2-0.1-0.5,0-0.7l0.7,2.8l0,0.6L78,52.1z"
      />
      <path
        fill={colors[3]}
        d="M80.8,52.3l0-0.2c0-0.3,0-0.5-0.1-0.8l-0.2-0.4l-0.1-0.4l0.1,0.2L80,48c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.6 l0.4-0.1l0,0.2c-0.1,0.2-0.1,0.5,0,0.7l0.5,2.7l0-0.6l1.8,9.2c-0.1,0.1-0.2,0.2-0.4,0.3L80.8,52.3z"
      />
      <path
        fill={colors[4]}
        d="M79.7,48.7c-0.1-0.2-0.2-0.5-0.2-0.8l0-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.5,2.8L79.7,48.7z"
      />
      <path
        fill={colors[4]}
        d="M80.5,50.7l-0.1-0.2l-0.5-2.8c0,0.1,0.1,0.2,0.1,0.3L80.5,50.7z"
      />
      <path
        fill={colors[5]}
        d="M80.4,46.8l0.4,0.8c0.1,0.3,0.2,0.5,0.1,0.8l-0.1,1.6l-0.5-2.8C80.3,47.1,80.3,47,80.4,46.8z"
      />
      <path
        fill={colors[5]}
        d="M80.2,48c0-0.2,0-0.5,0-0.7l0.5,2.8l0,0.6L80.2,48z"
      />
      <path
        fill={colors[6]}
        d="M83,58.8l-1-5.4l0.1,0.2l-0.5-2.7c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.6l0.4-0.1l0,0.2c-0.1,0.2-0.1,0.5,0,0.7 l0.5,2.7l0-0.6l1,5.3C83.3,58.4,83.1,58.6,83,58.8z"
      />
      <path
        fill={colors[7]}
        d="M81.3,51.5c-0.1-0.2-0.2-0.5-0.2-0.8l0-0.9c0.2,0.2,0.3,0.5,0.4,0.7l0.5,2.8L81.3,51.5z"
      />
      <path
        fill={colors[7]}
        d="M82.1,53.5L82,53.4l-0.5-2.8c0,0.1,0.1,0.2,0.1,0.3L82.1,53.5z"
      />
      <path
        fill={colors[8]}
        d="M82,49.7l0.4,0.9c0.1,0.3,0.1,0.5,0.1,0.8l-0.1,1.6l-0.5-2.8C81.9,49.9,81.9,49.8,82,49.7z"
      />
      <path
        fill={colors[8]}
        d="M81.8,50.8c0-0.2,0-0.5,0-0.7l0.5,2.8l0,0.6L81.8,50.8z"
      />
      <path
        fill={colors[6]}
        d="M80.6,54.3l0.1-0.6l1.1,6.3c-0.1,0.1-0.3,0.1-0.4,0.2l-1.1-6l0.1,0.2l-0.5-2.7c0-0.1-0.1-0.2-0.1-0.3 l-0.1-0.6l0.4-0.1l0,0.2c-0.1,0.2-0.1,0.5,0,0.7L80.6,54.3z"
      />
      <path
        fill={colors[7]}
        d="M79.6,52.3c-0.1-0.3-0.1-0.5-0.2-0.8l0-0.9c0.2,0.2,0.3,0.5,0.4,0.7l0.5,2.8L79.6,52.3z"
      />
      <path
        fill={colors[7]}
        d="M80.4,54.3l-0.1-0.2l-0.5-2.8c0,0.1,0.1,0.2,0.1,0.3L80.4,54.3z"
      />
      <path
        fill={colors[8]}
        d="M80.7,53.7l-0.5-2.8c0-0.1,0.1-0.3,0.2-0.4l0.2,0.5l0.3,1.4L80.7,53.7z"
      />
      <path
        fill={colors[8]}
        d="M80.8,52.1l0,0.2l-0.3-1.4l0.2,0.4C80.8,51.6,80.8,51.8,80.8,52.1z"
      />
      <path
        fill={colors[8]}
        d="M80.6,54.3l-0.5-2.7c0-0.2,0-0.5,0-0.7l0.5,2.8L80.6,54.3z"
      />
    </g>
  )
}

export default QuiverL
